// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__FIe1U","spinner":"Loading_spinner__3XILW"};